<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <div class="d-flex flex-row align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class="h5 font-weight-semibold">Riwayat Pengirim
                <i class="fa fa-info-circle fa" id="riwayatPengiriman"></i>
                    <b-popover
                    target="riwayatPengiriman"
                    title="QR Issue History"
                    triggers="hover focus"
                    placement="top"
                    :content="'Tabel ini menampilkan riwayat pengiriman QR ke dealer.'"
                    ></b-popover>
            </h3>
            <div class="d-flex flex-row align-items-center">
                <div class="d-flex flex-row align-items-center">
                    <div style="background-color: white; border-radius: 4px; position: relative; border: 0">
                        <span style="pointer-events: none; position: absolute; top: 0; bottom: 0; inset-inline-start: 0px; width: 40px; place-content: center; color: rgb(107 114 128); display: grid;">
                            <i class="fas fa-calendar"></i>
                        </span>
                        <flat-pickr v-model="selected.date" :config="dateRangeConfig"></flat-pickr>
                    </div>
                    <div style="width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['INTRANSIT' , 'RECEIVED']"
                            class="qtrust-select"
                            placeholder="Semua Status"
                        ></MultiSelect>
                    </div>
                    <div style="width: 200px; margin-left: 20px;">
                        <button
                            class="btn mpm-button shadow w-100"
                            @click="$emit('showMetodeModal')"
                        >
                            Buat Delivery
                        </button>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100">
                <thead>
                    <tr>
                        <!-- <th class="text-left border-top border-bottom" style="vertical-align: middle; padding: 8px 16px; border-color: #F3F3F3; height: 50px;">No PO</th> -->
                        <th class="text-left border-top border-bottom" style="vertical-align: middle; padding: 8px 16px; border-color: #F3F3F3">Tanggal Pengiriman</th>
                        <th class="text-left border-top border-bottom" style="vertical-align: middle; padding: 8px 16px; border-color: #F3F3F3">Jumlah QR</th>
                        <th class="text-left border-top border-bottom" style="vertical-align: middle; padding: 8px 16px; border-color: #F3F3F3">Kode Dealer</th>
                        <th class="text-left border-top border-bottom" style="vertical-align: middle; padding: 8px 16px; border-color: #F3F3F3">Status</th>
                        <th class="text-left border-top border-bottom" style="vertical-align: middle; padding: 8px 16px; border-color: #F3F3F3">Kode BAST</th>
                        <th class="text-left border-top border-bottom" style="vertical-align: middle; padding: 8px 16px; border-color: #F3F3F3">Tanggal Receipt</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dat in data">
                        
                        <td class="text-left border-bottom" style="vertical-align:middle; padding: 8px 16px; border-color: #F3F3F3">{{ dat.delivery_date }}</td>
                        <td class="text-left border-bottom" style="vertical-align:middle; padding: 8px 16px; border-color: #F3F3F3">{{ dat.qty }}</td>
                        <td class="text-left border-bottom" style="vertical-align:middle; padding: 8px 16px; border-color: #F3F3F3; height: 50px;">K0000</td>
                        <!-- Status Start -->
                        <td class="text-left border-bottom" style="vertical-align:middle; padding: 8px 16px; border-color: #F3F3F3">{{ dat.status }}</td>
                        
                        <!-- <td class="text-left border-bottom" style="vertical-align:middle; padding: 8px 16px; border-color: #F3F3F3" v-else>
                            <MultiSelect
                                v-model="dat.status"
                                :options="['In-Transit', 'Received']"
                                class="qtrust-select"
                                :allow-empty="false"
                                placeholder="Pilih Status"
                            ></MultiSelect>
                        </td> -->
                        <!-- Status End -->
                        <td class="text-left border-bottom" style="vertical-align:middle; padding: 8px 16px; border-color: #F3F3F3; height: 50px;">{{ dat.po_no }}</td>

                        <td class="text-left border-bottom" style="vertical-align:middle; padding: 8px 16px; border-color: #F3F3F3">
                            {{ dat.receipt_date ? dat.receipt_date : '-' }}
                            <i v-if="dat.receipt_date" class="fa fa-file-download ml-2 clickAble" title="Download BAST"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3">
            <p class="text-muted mb-0">Showing 1-5 of 7 items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">1</p>
                <button class="btn btn-link px-1" style="color: #627884"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        data () {
            let start = moment().subtract(14, 'days').format("YYYY-MM-DD");
            let end = moment().format("YYYY-MM-DD");
            return {
                dateRangeConfig: {
                    mode: "range",
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altInputClass: "flatpickr-alt",
                    maxDate: moment().format("YYYY-MM-DD"),

                    //Max number of days
                    onChange: (selectedDates, dateStr, instance) => {
                        if (selectedDates.length == 1) {
                            let fourteenDaysLater = new Date(
                                selectedDates[0].getTime() + 86400000 * 14
                            )
                            // console.log(
                            //     '14 days later is: ',
                            //     fourteenDaysLater,
                            //     selectedDates[0]
                            // )

                            instance.config.minDate = selectedDates[0].toUTCString()
                            instance.config.maxDate = fourteenDaysLater.toUTCString()
                        } else if (selectedDates.length == 2) {
                            instance.config.minDate = null
                            instance.config.maxDate = end
                        }
                    },
                },
                data : [
                    {
                        po_no: "1/PO/20/03/2024",
                        delivery_date: "01 Jan 2024 | 13:24",
                        qty: "50.000",
                        status: "Received",
                        receipt_date: "03 Jan 2024 | 15:20"
                    },
                    {
                        po_no: "2/PO/20/03/2024",
                        delivery_date: "12 Jan 2024 | 14:32",
                        qty: "10.000",
                        status: "In-Transit",
                        receipt_date: null
                    },
                    {
                        po_no: "3/PO/20/03/2024",
                        delivery_date: "12 Jan 2024 | 14:32",
                        qty: "5.000",
                        status: "In-Transit",
                        receipt_date: null
                    },
                ],

                selected: {
                    date: `${start} to ${end}`,
                },
                filter : {
                    year: null,
                    date: {
                        start: start,
                        end: end
                    }
                },
            }
        },
        watch : {
            'selected.date'() {
                let dates = this.selected.date.split(' to ');
                this.filter.date.start = dates[0];
                this.filter.date.end = dates[1] ? dates[1] : dates[0];

                setTimeout(() => {
                    this.generateDatas();
                }, 1000);
            }
        },
    }
</script>

<style>
    .flatpickr-alt {
        font-size: 14px;
        min-width: 260px;
        padding: 0 12px;
        height: 32px;
        background-color: transparent;
        padding-inline-start: 40px;
        cursor: pointer;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
    }

    .qtrust-select {
        min-height: 0;
    }

    .qtrust-select .multiselect__tags {
        min-height: 0;
        height: 32px;
        padding: 4px 40px 0 8px;
    }

    .qtrust-select .multiselect__tags .multiselect__placeholder {
        margin: 0;
        padding: 0;
        font-size: 14px;
    }

    .qtrust-select .multiselect__select {
        height: 32px;
    }

    .qtrust-select .multiselect__select::before {
        z-index: 1;
        margin: 0;
    }

    .qtrust-select .multiselect__single {
        margin: 0;
        font-size: 14px;
    }
</style>

<style scoped>
    .clickAble:hover {
        cursor: pointer;
        opacity: 70%;
    }
</style>